import { render, staticRenderFns } from "./FormularioContactoProyecto.vue?vue&type=template&id=246b4802&scoped=true&"
import script from "./FormularioContactoProyecto.vue?vue&type=script&lang=js&"
export * from "./FormularioContactoProyecto.vue?vue&type=script&lang=js&"
import style0 from "./FormularioContactoProyecto.vue?vue&type=style&index=0&id=246b4802&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246b4802",
  null
  
)

export default component.exports